import ManualBreadcrumb from '../../components/manual/ManualBreadcrumb';
import ManualSection from '../../components/manual/ManualSection';
import ManualAlert from '../../components/manual/ManualAlert';

function ManualDashboardPage() {
  return (
    <div className="manual-page">
      <ManualBreadcrumb items={[{ label: 'Painel de Controle' }]} />
      
      <div className="manual-header">
        <h1 className="manual-title">
          <i className="bi bi-speedometer2 me-3"></i>
          Painel de Controle (Dashboard)
        </h1>
        <p className="manual-subtitle">
          Visualize informações e estatísticas em tempo real
        </p>
      </div>

      <ManualSection icon="bi-info-circle" title="O que é o Dashboard?">
        <p>
          O Dashboard (Painel de Controle) é a tela inicial do sistema após o login.
          Ele oferece uma visão operacional das movimentações, com atualização em tempo real,
          filtros rápidos e cartões de atendimento por área.
        </p>
        <ManualAlert type="tip">
          As informações do dashboard são atualizadas automaticamente em tempo real.
          Não é necessário recarregar a página!
        </ManualAlert>
      </ManualSection>

      <ManualSection icon="bi-funnel" title="Filtros e Totalizadores">
        <p>
          No topo do dashboard ficam os controles principais:
        </p>
        <ul className="manual-list">
          <li><strong>Status:</strong> Abertos, Finalizados ou Todos</li>
          <li><strong>Data:</strong> filtra movimentações do dia escolhido</li>
          <li><strong>Busca:</strong> filtra localmente pelo nome do adolescente</li>
          <li><strong>Efetivo Total:</strong> quantidade de movimentações no período carregado</li>
          <li><strong>Em aberto e Finalizadas:</strong> totais calculados a partir do mesmo conjunto</li>
        </ul>

        <ManualAlert type="info">
          Ao clicar novamente em <strong>Painel</strong> no menu lateral, a tela volta para
          o contexto padrão: data de hoje, status <strong>Abertos</strong> e busca vazia.
        </ManualAlert>
      </ManualSection>

      <ManualSection icon="bi-card-heading" title="Entendendo as Movimentações">
        <p>
          As movimentações são agrupadas por <strong>Meio de Entrada</strong>. Cada grupo mostra
          seu nome, ícone e a quantidade de movimentações naquele grupo.
        </p>

        <div className="manual-dashboard-card">
          <div className="manual-card-badge manual-card-badge-blue">
            <i className="bi bi-person-walking"></i>
          </div>
          <div>
            <h5>Apresentação Espontânea</h5>
            <p>Adolescentes que se apresentaram voluntariamente</p>
          </div>
        </div>

        <div className="manual-dashboard-card">
          <div className="manual-card-badge manual-card-badge-red">
            <i className="bi bi-lightning-charge"></i>
          </div>
          <div>
            <h5>Flagrante</h5>
            <p>Adolescentes apreendidos em flagrante</p>
          </div>
        </div>

        <div className="manual-dashboard-card">
          <div className="manual-card-badge manual-card-badge-orange">
            <i className="bi bi-clipboard-data"></i>
          </div>
          <div>
            <h5>MBA</h5>
            <p>Por Mandado de Busca e Apreensão</p>
          </div>
        </div>

        <div className="manual-dashboard-card">
          <div className="manual-card-badge manual-card-badge-purple">
            <i className="bi bi-building"></i>
          </div>
          <div>
            <h5>CDP</h5>
            <p>Vindos da Casa de Detenção Provisória</p>
          </div>
        </div>

        <h4 className="mt-4">Como usar os cards</h4>
        <p>
          O cabeçalho de cada movimentação mostra adolescente, decisão, situação, motivo MBA
          quando aplicável e data de referência. Clique nesse cabeçalho para abrir o resumo
          da movimentação, editar dados permitidos, finalizar, reabrir ou excluir conforme permissões.
        </p>
      </ManualSection>

      <ManualSection icon="bi-clipboard-check" title="Cards de Atendimentos">
        <p>
          Abaixo do cabeçalho da movimentação ficam os cartões das áreas:
        </p>
        <ul className="manual-list">
          <li><strong>Promotoria:</strong> promotor, horário, entrada e saída</li>
          <li><strong>Saúde:</strong> entrada, saída e indicação de bloqueio quando aplicável</li>
          <li><strong>Educação:</strong> entrada, saída e bloqueio para MBA ou fim de semana/feriado</li>
          <li><strong>Defensoria/Adv:</strong> representante, entrada e saída</li>
          <li><strong>Especialistas:</strong> especialista, responsável presente, entrada e saída</li>
        </ul>
        
        <ManualAlert type="info">
          Os cartões ficam clicáveis apenas quando o usuário tem permissão de atendimento e a
          regra operacional permite a ação.
        </ManualAlert>
      </ManualSection>

      <ManualSection icon="bi-clock-history" title="Informações em Tempo Real">
        <p>
          O dashboard mostra tudo o que está acontecendo agora:
        </p>
        <ul className="manual-list">
          <li>Movimentações criadas ou atualizadas são refletidas automaticamente</li>
          <li>Finalizações removem itens do filtro Abertos e entram em Finalizados</li>
          <li>Alterações em atendimentos destacam a movimentação e o cartão correspondente</li>
          <li>Dados são recebidos via WebSocket sem precisar recarregar a página</li>
        </ul>
        
        <ManualAlert type="success">
          Mantenha o dashboard aberto para acompanhar as atividades do dia em tempo real!
        </ManualAlert>
      </ManualSection>

      <ManualSection icon="bi-palette" title="Tema do Dashboard">
        <p>
          O dashboard possui tema claro e escuro próprios. A preferência é independente do tema
          aplicado às demais páginas do painel e é salva na sua conta quando possível.
        </p>
      </ManualSection>
    </div>
  );
}

export default ManualDashboardPage;
